export const SAENGGIBU_FAST_MODE = 'gemini-2.5-flash-lite';
export const SAENGGIBU_ADVANCED_MODE = 'gemini-2.5-flash';

// 예전 기록에는 gpt-4.1·gpt-5 같은 종료 모델이나 런타임 모델명(gemini-3.1-flash-lite)이 저장돼 있다.
// 화면에는 빠른·고급 두 칸만 있으므로 백엔드(saenggibu_model_selection.py)와 같은 규칙으로 맞춘다.
export const restoreSaenggibuModelMode = (storedModel, isProUser) => {
  const value = String(storedModel || '').trim().toLowerCase();
  if (!value) return null;
  if (value === SAENGGIBU_FAST_MODE || value === SAENGGIBU_ADVANCED_MODE) return value;
  if (!isProUser || value.includes('flash-lite')) return SAENGGIBU_FAST_MODE;
  return SAENGGIBU_ADVANCED_MODE;
};
